import type Channel from "./Channel";
import { ButtonSide, RockerConfig } from "./ButtonRockerConfig";

export function canToggleButtonChannelSplit(channel: Channel): boolean {
  return channel.isButtonChannel && channel.isRequestChannel && channel.supportsRockerConfig
    && !channel.isStatusChannel && !channel.isLogicChannel
    && (channel.rockerConfig === RockerConfig.rocker
      || (channel.rockerConfig === RockerConfig.none && channel.buttonSide === ButtonSide.both)
      || channel.buttonSide === ButtonSide.left || channel.buttonSide === ButtonSide.right);
}
